<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps({
  number: {
    type: Number,
    required: true,
  },
  effect: {
    type: String as () => 'slide' | 'pop',
    default: 'slide',
    validator: (val: string) => ['slide', 'pop'].includes(val),
  }
});

const odometerArray = ref([props.number - 1, props.number, props.number + 1]);
const currentNumber = ref(props.number);

const changeOdometer = () => {
  if (currentNumber.value === props.number) return

  if (Math.abs(currentNumber.value - props.number) === 1) {
    if (props.number > currentNumber.value) {
      odometerArray.value.push(props.number + 1);
      odometerArray.value.shift();
    } else {
      odometerArray.value.splice(0, 0, props.number - 1);
      odometerArray.value.pop();
    }
  } else {
    odometerArray.value = [props.number - 1, props.number, props.number + 1];
  }
  currentNumber.value = props.number;
}

watch(
  () => props.number,
  () => {
    changeOdometer()
  },
)
</script>

<template>
  <ul
    class="odometer flex flex-col m-0 p-0 overflow-hidden relative mb-0 h-full top-0 left-0 font-bold"
    :class="effect === 'slide' ?  'effect-slide' : 'effect-pop'"
  >
    <li
      v-for="(item, key) in odometerArray"
      :key="item"
      class="text-center w-full text-center h-full flex items-center justify-center"
      :class="[{ 'prev absolute': key < 1 }, { 'next absolute': key > 1 }]"
    >
      {{ item }}
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.odometer {
  &.effect-slide {
    li {
        transition: .2s all linear;
        transform: translateY(0%);

        &.prev { transform: translateY(-100%); }
        &.next { transform: translateY(100%); }
    }
  }
  &.effect-pop {
    @keyframes popEffect {
      from {transform: scale(.3);}
      to {transform: scale(1);}
    }
    li {
      transition: .2s all linear;
      animation: .2s popEffect cubic-bezier(.46,2.06,.6,1) forwards;

        &.prev { animation: none; transform: scale(0); }
        &.next { animation: none; transform: scale(0); }
    }
  }
}
</style>
